module.exports = "<app-edit-panel *ngIf=\"editProgram\"></app-edit-panel>\r\n<app-active-program *ngIf=\"ap\"></app-active-program>\r\n<app-program-list *ngIf=\"listProgram\"></app-program-list>\r\n<app-zero-ret *ngIf=\"zeroRet\"></app-zero-ret>\r\n<app-ofset *ngIf=\"offset\"></app-ofset>\r\n<app-mdi *ngIf=\"mdi\"></app-mdi>\r\n<app-active-program1 *ngIf=\"aProgram1\"></app-active-program1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/wrapper-panels.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/wrapper-panels.component.html
// module chunks = main